import React from 'react';
import { Check } from 'lucide-react';

const steps = [
  { number: 1, title: 'Informações Básicas' },
  { number: 2, title: 'Mídia e Estilo' },
  { number: 3, title: 'Links Sociais' },
  { number: 4, title: 'Links Personalizados' },
];

const StepIndicator = ({ currentStep }) => {
  return (
    <div className="mb-8">
      {/* Progress Bar */}
      <div className="relative mb-6">
        <div className="h-1 bg-slate-200 rounded-full">
          <div
            className="h-1 bg-blue-500 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
          />
        </div>
        
        {/* Step Dots */}
        <div className="absolute top-1/2 -translate-y-1/2 w-full flex justify-between">
          {steps.map((step) => (
            <div
              key={step.number}
              className={`w-4 h-4 rounded-full border-2 transition-all duration-300 ${
                currentStep > step.number
                  ? 'bg-blue-500 border-blue-500'
                  : currentStep === step.number
                  ? 'bg-white border-blue-500'
                  : 'bg-white border-slate-300'
              }`}
            >
              {currentStep > step.number && (
                <Check className="w-3 h-3 text-white" style={{ margin: '-1px' }} />
              )}
            </div>
          ))}
        </div>
      </div>
      
      {/* Current Step Title */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center font-semibold text-lg shadow-md">
          {currentStep}
        </div>
        <h2 className="text-xl font-semibold text-slate-800">
          {steps[currentStep - 1].title}
        </h2>
      </div>
    </div>
  );
};

export default StepIndicator;
